import { Form } from 'shared/components/Form';
import styled from 'styled-components';

export const StyledEnterAssayResultsForm = styled(Form)`
    h5 {
      color: var(--geyser);
      margin-bottom: 35px;
    }
`;
